export const pageNames = {
  Map: "Map",
  Reports: "Reports",
};
